import { Button, Tooltip } from "antd"
import React from "react"
import { withRouter } from "react-router-dom"
import "./IntegrationSetup.scss"
import deliveryIcon from "../../assets/images/deliveryIcon.png"
import locationIcon from "../../assets/images/locationIcon.png"
import helpIcon from "../../assets/images/BG_help.png"
import deliveryTextIcon from "../../assets/images/deliveryTextIcon.png"

const IntegrationSetup = (props) => {
  return (
    //  <div>
    <div id="integrationSetup">
      {props.data.map((info) => (
        <div id="mainContainer" key={info.key}>
          <div className="icon">
            {info.key === "delivery" ? (
              <img src={deliveryIcon} alt="Delivery.com"></img>
            ) : (
              <img src={locationIcon} alt="delivery" />
            )}
          </div>
          <div id="headingAndExplainText">
            <div className="heading">
              {info.heading + " "}
              {info.key === "delivery" ? (
                <img src={deliveryTextIcon} alt="Delivery.com"></img>
              ) : (
                ""
              )}
            </div>
            <div className="explainText">{info.explainText}</div>
          </div>
          <div className="btntooltipbox">
            <div id="buttonContainer">
              <div>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={
                    info.key === "location" && props.changeText ? true : false
                  }
                  onClick={() => props.handleClick(info.key)}
                >
                  {info.key === "location" && props.changeText
                    ? "Allowed"
                    : "Allow"}
                </Button>
              </div>
            </div>
            <div className="whatsThisIcon">
              <div>
                <Tooltip placement="rightTop" title={info.toolTipText}>
                  <img src={helpIcon} alt="help"></img>
                  <span className="tooltipText">?</span>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default withRouter(IntegrationSetup)
